import { findKey, has } from 'lodash'
import { Query } from '../generated/gatsby.types'

export default (data: Query) => findKey(data, (entry) => has(entry, 'slug'))
